import type { ColumnFiltersState, ColumnVisibilityState, SortingState } from '@tanstack/table-core'

import { z } from 'zod'

export interface TableSettingsState {
  columnVisibility: ColumnVisibilityState
  sorting: SortingState
  columnFilters: ColumnFiltersState
  columnOrder: string[]
  version: number
  /**
   * The `resetFiltersKey` (e.g. the viewed wallet address) the persisted
   * `columnFilters` were saved under. Lets `useTableSettings` drop filters when
   * the key changes across a remount — see that hook. Absent for tables that
   * don't opt into filter scoping.
   */
  filtersOwnerKey?: string
}

export type EditableTableSettingsState = Omit<TableSettingsState, 'version'>

export const TableSettingsStateSchema = z.object({
  columnVisibility: z.record(z.string(), z.boolean()),
  sorting: z.array(
    z.object({
      id: z.string(),
      desc: z.boolean()
    })
  ),
  columnFilters: z.array(
    z.object({
      id: z.string(),
      value: z.unknown().refine(value => value !== undefined, {
        message: 'Value must not be undefined'
      })
    })
  ),
  columnOrder: z.array(z.string()),
  version: z.number(),
  filtersOwnerKey: z.string().optional()
})
